import { getJson, setViewRenderedTrue, hasViewRendered } from '../assets/snize-utility.js'
import { timeout } from '../assets/utils.js'
import frel from '../assets/frel.js'
import snizeQuickLinkSearchBar from '../assets/snize-quick-link-search-bar.js'
import snizeRelatedSearchFooter from '../assets/snize-related-search-footer.js'

// Variables
const pageContainer = document.querySelector('[data-search-page-container]')
const config = { attributes: true, childList: true, subtree: true }

const selector = {
    horizontalRight: '.snize-horizontal-right',
    dropDownActiveOption: '.snize-main-panel-dropdown-button > span',
    categoryListContainer: '#snize-search-results-list-mode',
    categoryListItem: '.snize-category',
    initerstitialBlock: '.snize-product-tag-functionality-search-interstitial-block'
}

// Module specific utility functions
const createSpanWithItemCount = (count) => frel('span', { class: 'snize-item-count' }, `${count} items`)

const checkIfUrlParamsHasTabCategory = () => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('tab') === 'category';
}

const findUniqueFirstLetterOfEach = (categories) => {
    if (!categories) return
    const titles = categories.map(category => category.title)
    const uniqueFirstLetters = new Set()
    titles.forEach(title => {
        const firstLetter = title[0]
        uniqueFirstLetters.add(firstLetter)
    })
    return Array.from(uniqueFirstLetters)
}

const createUl = (items) => {
    const ul = frel('ul', { class: 'snize-category-filters' })
    ul.append(...items)
    return ul
}

const createLi = (letter) => {
    const li = frel('li', { class: 'snize-category-filter' })
    const link = ''
    const a = frel('a', { href: link, class: 'snize-category-filter-link' }, letter)
    a.setAttribute('data-snize-category-filter', letter)
    li.appendChild(a)
    return li
}

const createAllListItem = () => {
    const li = frel('li', { class: 'snize-category-filter' })
    const a = frel('a', { href: '', class: 'snize-category-filter-link' }, 'All')
    a.setAttribute('data-snize-category-filter', 'all')
    li.appendChild(a)
    return li
}

const creatItemsList = (categories) => {
    const items = findUniqueFirstLetterOfEach(categories).map(createLi)
    const sortedItems = items.sort((a, b) => a.textContent.localeCompare(b.textContent))
    return sortedItems
}

const generateCategorySideBarFilter  = (categories) => {
    const items = creatItemsList(categories)
    const ul = createUl(items)
    return ul
}

const removeFilterFromCategoryList = () => {
    const categoryList = document.querySelectorAll(selector.categoryListItem)
    categoryList.forEach(category => {
        category.style.display = 'block'
    })
}

const filterCategoriesListByFirstLetter = (letter) => {
    const categoryList = document.querySelectorAll(selector.categoryListItem)
    categoryList.forEach(category => {
        const title = category.textContent
        if (title[0].toLowerCase() === letter.toLowerCase()) {
            category.style.display = 'block'
        } else {
            category.style.display = 'none'
        }
    })
}

const snizeLetterBasedFiltering = (result) => {
    const { child } = result ?? {}
    const filterAnchors = child.querySelectorAll('[data-snize-category-filter]')

    filterAnchors.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault()
            const letter = e.target.dataset.snizeCategoryFilter
            if (letter === 'all' || letter ===  'All') {
                removeFilterFromCategoryList()
            } else {
                filterCategoriesListByFirstLetter(letter)
            }

        })
    })

    const filterSiderBar = document.querySelector('.snize-category-filters')

    if (checkIfUrlParamsHasTabCategory()) {
        filterSiderBar.style.display = 'block'
    } else {
        filterSiderBar.style.display = 'none'

    }
}

// Strategies
const strategies = {
    replaceNode: (result) => {
        if (!result.original.matches('[data-view-rendered="true"]')) {
            setViewRenderedTrue(result.newNode)
            result.original.replaceWith(result.newNode)
            result.callback && result?.callback(result)
        }
    },
    appendChild: (result) => {
        if (!result.original.querySelector('[data-view-rendered="true"]')) {
            setViewRenderedTrue(result.child)
            result.original.appendChild(result.child)
            result.callback && result.callback(result)
        }
    }
}

// Middleware
const checkIfIsRelevantChange = (mutation) => {
    const { target } = mutation ?? {}
    return target.dataset.viewRendered !== 'true'
}

// Models
const searchHorizontalRightModel = async (element) => {
    if (!element || hasViewRendered(element)) return

    try {
        const results = await getJson()
        const { totalItems } = results ?? {}
        const spanTag = createSpanWithItemCount(totalItems)

        return {
            replaceNode: false,
            appendChild: true,
            child: spanTag,
            original: element
        }
    } catch (error) {
        console.error("Error in searchHorizontalRightModel:", error)
    }
}

const searchDropDownModel = async (element) => {
    if (!element || hasViewRendered(element)) return
    const clone = element.cloneNode(true)
    clone.innerText = `SORT BY: ${element.innerText}`

    return {
        replaceNode: true,
        appendChild: false,
        newNode: clone,
        original: element
    }
}

const categoriesFilterModel = async (element) => {
    if (!element || hasViewRendered(element)) return

    try {
        const useCache = false
        const results = await getJson(useCache, 'test0r1')
        const { categories } = results ?? {}
        const filterSideBar = generateCategorySideBarFilter(categories)
        filterSideBar.prepend(createAllListItem())
        return {
            replaceNode: false,
            appendChild: true,
            child: filterSideBar,
            original: element,
            callback: snizeLetterBasedFiltering
        }
    } catch (error) {
        console.error("Error in categoriesFilterModel", error)
    }
}

// View
const view = (result) => {
    if (!result) return

    for (let key in strategies) {
        if (result[key]) {
            strategies[key](result)
        }
    }
}

// Controller
const controller = async (mutation) => {
    let results = []  

    // Check if the mutation target or its children match the horizontalRight selector
    if (pageContainer.querySelector(selector.horizontalRight) || mutation.target.matches(selector.horizontalRight)) {
        results.push(await searchHorizontalRightModel(pageContainer.querySelector(selector.horizontalRight)))
    }

    // Check if the mutation target or its children match the dropDownActiveOption selector
    if (pageContainer.querySelector(selector.dropDownActiveOption) || mutation.target.matches(selector.dropDownActiveOption)) {
        results.push(await searchDropDownModel(pageContainer.querySelector(selector.dropDownActiveOption)))
    }

    // Check if the mutation target or its children match the categoryListContainer selector
    if (pageContainer.querySelector(selector.categoryListContainer) || mutation.target.matches(selector.categoryListContainer)) {
        results.push(await categoriesFilterModel(pageContainer.querySelector(selector.categoryListContainer)))
    }

    return results  // Return the collected results
}

let mutationsObserved = false;

const handleMutation = (mutation) => {

    if (mutationsObserved) return;
    mutationsObserved = true;

    timeout(500).then(async () => {
        if (!checkIfIsRelevantChange(mutation)) {
            mutationsObserved = false;
            return
        }

        const resultsArray = await controller(mutation)

        for (const result of resultsArray) {
            view(result)
        }

        const event = new CustomEvent('searchVewUpdated', { detail: { resultsArray } })
        document.dispatchEvent(event)

        mutationsObserved = false
    })
}

if (pageContainer) {
    const callback = (mutationList) => mutationList.forEach(mutation => handleMutation(mutation))

    const observer = new MutationObserver(callback)
    observer.observe(pageContainer, config)

    snizeRelatedSearchFooter()
    snizeQuickLinkSearchBar()
}

if (window.location.pathname === '/pages/search-results-page') {
    const urlParam = new URLSearchParams(window.location.search)
    window.location = '/search?q=' + urlParam.get('q')
}